import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {
  private _uri = environment.api.uri;
  private _http = inject(HttpClient);

  post<T>(url: string, body: any): Observable<T> {
    return this.httpRequest('post', url, { body: body });
  }

  get<T>(url: string, params?: any): Observable<T> {
    return this.httpRequest('get', url, { params: params });
  }

  put<T>(url: string, body: any): Observable<T> {
    return this.httpRequest('put', url, { body: body });
  }

  patch<T>(url: string, body: any): Observable<T> {
    return this.httpRequest('patch', url, { body: body });
  }

  delete(url: string): Observable<any> {
    return this.httpRequest('delete', url, {});
  }

  private httpRequest(method: string, url: string, options: any): Observable<any> {
    return this._http.request(method, `${this._uri}${url}`, { ...options }).pipe(take(1));
  }
}
